import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmail, findUserDocbyId } from "../firebase/firebase.config";
import { Link } from "react-router-dom";

import { useDispatch } from "react-redux";
import { loadUser } from "../store/userSlice";

function Signin() {
  const [formData, setFormData] = useState({});
  const [error, setError] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  const inputStyle = "w-full rounded p-1 text-sm py-2 border border-gray-300";
  const labelStyle = "text-left font-bold text-gray-500 text-sm";

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
   
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    const signIn = async () => {
      try {
        setIsProcessing(true);
        const res = await signInWithEmail(formData.email, formData.password);
        if (res) {
          const { email, uid } = res.user;
          const { displayName } = await findUserDocbyId(res.user.uid);

          dispatch(loadUser({ email, displayName, uid }));
          navigate("/");
        }
        setIsProcessing(false);
      } catch (error) {
        setError(error.message);
      }
    };
    signIn();
  };

  return (
    <div
      className="h-screen bg-gray-200 flex flex-col items-center justify-center gap-4"
      style={{
        background:
          "url('https://plus.unsplash.com/premium_photo-1701121214437-95ddcfc131bc?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D') no-repeat center center fixed",

        opacity: "0.85",
      }}
    >
      <div className="text-center text-white font-bold bg-orange-400 p-4 rounded w-80">
        Friday.com
      </div>
      <form
        className="flex flex-col w-10/12 items-center gap-2 bg-gray-100 p-4 lg:w-96"
        onSubmit={handleSubmit}
      >
        <div className="font-bold text-orange-500 uppercase">Welcome Back</div>

        <div className="w-10/12">
          <label className={labelStyle} htmlFor="">
            Email Address
          </label>
          <input
            className={inputStyle}
            type="email"
            placeholder="Enter Email Address"
            name="email"
            onChange={handleChange}
            required
          />
        </div>

        <div className="w-10/12">
          <label className={labelStyle} htmlFor="">
            Password
          </label>
          <input
            className={inputStyle}
            type="password"
            placeholder="Nominate your password"
            name="password"
            onChange={handleChange}
            required
          />
        </div>

        <button
          disabled={isProcessing}
          type="submit"
          className="bg-blue-500 rounded-md text-white px-4 py-2 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isProcessing ? "Processing..." : "Sign in"}
        </button>
        {error && <div className="text-red-500">{error}</div>}
        <div>
          No Account Yet? Sign up instead <Link to='/signup'>here</Link>
        </div>
        <Link to='/resetpassword'>Forgot my password</Link>
      </form>
    </div>
  );
}

export default Signin;
